import { useContext, useEffect, useState } from "react";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import { useNavigate, Link } from "react-router-dom";
import {
  Button,
  Typography,
  Container,
  Box,
  Paper,
  Divider,
} from "@mui/material";
import { apiRequest } from "../services/apiService";

// Ikony MUI
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VolunteerActivismIcon from "@mui/icons-material/VolunteerActivism";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";

export default function Menu() {
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    if (userData) {
      const fetchData = async () => {
        try {
          const response = await apiRequest("getpossibilities", "GET");
          if (Array.isArray(response)) {
            setOptions(response);
            console.log("response: ", response);
          } else {
            setOptions([]);
          }
        } catch (error) {
          console.log(error.message);
        }
      };
      fetchData();
    }
  }, [userData, inputValue]);

  return (
    <Box sx={{ backgroundColor: "#f8fafc", minHeight: "100vh", pb: 6 }}>
      <VN userData={userData} />

      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <Paper
          elevation={0}
          sx={{
            p: 4,
            borderRadius: "16px",
            border: "1px solid #e2e8f0",
            boxShadow: "0 10px 30px rgba(0, 0, 0, 0.04)",
            backgroundColor: "#ffffff",
          }}
        >
          {/* NAGŁÓWEK PANELU */}
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: "#1e293b",
                letterSpacing: "-0.5px",
                mb: 1,
              }}
            >
              Panel Administratora
            </Typography>
            <Typography variant="body1" sx={{ color: "#64748b" }}>
              Zarządzaj strukturą opiekunek i pielęgniarek w serwisie.
            </Typography>
          </Box>

          <Divider sx={{ mb: 4 }} />

          {/* PASEK PRZYCISKÓW W JEDNEJ LINII */}
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
              gap: 2,
              justifyContent: "flex-start",
              alignItems: "stretch",
            }}
          >
            <Button
              variant="contained"
              startIcon={<LocalHospitalIcon />}
              // onClick={handleSubmit}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor: "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Dopisanie pielęgniarki
            </Button>

            <Button
              variant="contained"
              startIcon={<VolunteerActivismIcon />}
              // onClick={handleSubmit}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor: "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Dopisanie opiekunki
            </Button>

            <Button
              variant="contained"
              startIcon={<AssignmentIndIcon />}
              // onClick={handleSubmit}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor: "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Przypisanie opiekunki do pielęgniarki
            </Button>
            <Button
              variant="contained"
              startIcon={<AssignmentIndIcon />}
              // onClick={handleSubmit}
              sx={{
                flex: 1,
                py: 1.5,
                px: 3,
                fontWeight: 600,
                fontSize: "0.95rem",
                borderRadius: "10px",
                textTransform: "none",
                backgroundColor: "#1a237e",
                boxShadow: "0 4px 12px rgba(26, 35, 126, 0.2)",
                "&:hover": {
                  backgroundColor: "#0d1b60",
                  boxShadow: "0 6px 16px rgba(26, 35, 126, 0.3)",
                },
              }}
            >
              Lista niezweryfikowanych opiekunek
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
